import { render, staticRenderFns } from "./tags-tool.vue?vue&type=template&id=643f3a1a"
import script from "./tags-tool.vue?vue&type=script&lang=js"
export * from "./tags-tool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports